import type { QueryLanguageEditorHandle, QueryLanguageEditorInitProps } from "../src/query_language_editor/types/init";

type Main = typeof import("../src/query_language_editor/main");
let mainLoading: Promise<Main> | undefined;

// init and destroy chain on one import promise, so a destroy issued before the chunk loads still runs
// after its init. A failed import is dropped so the next init retries it.
const loadMain = (): Promise<Main> =>
  (mainLoading ||= import("../src/query_language_editor/main").catch((error: unknown) => {
    mainLoading = undefined;
    throw error;
  }));

window.EasyQueryLanguageEditor ||= {};

window.EasyQueryLanguageEditor.init = (
  wrapperId: string,
  props: QueryLanguageEditorInitProps
): QueryLanguageEditorHandle => {
  const root = document.getElementById(wrapperId);
  const handleLoading = loadMain().then(main => main.init(wrapperId, props, root));

  return {
    setValue: text => handleLoading.then(handle => handle.setValue(text)),
    setDisabled: disabled => handleLoading.then(handle => handle.setDisabled(disabled)),
    focus: () => handleLoading.then(handle => handle.focus()),
    destroy: () => handleLoading.then(handle => handle.destroy()),
  };
};

// Nothing to destroy before the first init. init already reports a failed import, so only that rejection
// is ignored here.
window.EasyQueryLanguageEditor.destroy = (wrapperId: string): void => {
  void mainLoading?.then(
    main => main.destroy(wrapperId),
    () => undefined
  );
};
